{
    "extensions": [
        {
            "extensionPoint": "universal-editor/ui/1"
        }
    ]
}